import { Component } from "@angular/core";

@Component({
    selector: 'app-sin-contenido',
    templateUrl: 'sin-contenido.component.html'
})

export class SinContenidoComponent {

}